export default {
  FETCH_MOVIES: 'FETCH_MOVIES',
  FETCH_MOVIES_START: 'FETCH_MOVIES_START',
  FETCH_MOVIES_SUCCESS: 'FETCH_MOVIES_SUCCESS',
  FETCH_MOVIES_FAILURE: 'FETCH_MOVIES_FAILURE',
  FETCH_MORE_MOVIES: 'FETCH_MORE_MOVIES',
  FETCH_MORE_MOVIES_START: 'FETCH_MORE_MOVIES_START',
  FETCH_MORE_MOVIES_SUCCESS: 'FETCH_MORE_MOVIES_SUCCESS',
  FETCH_MORE_MOVIES_FAILURE: 'FETCH_MORE_MOVIES_FAILURE',
};
